import React from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { object, string } from "yup";

import { sendCredentialVerfication } from "../../../Api/Signin/Signin.Api";
import useLoadingState from "../../../Utils/Hooks/useLodingState";
import JwtDecoder from "../../../Utils/JwtDecoder/JwtDecoder";
import { PasswordInput } from "../../atoms/Input/PasswordInput";
import { LoadingButtonType } from "../../atoms/LoadingButton/LoadingButton";
import { SubHeader4 } from "../../atoms/Typography/SubHeader/SubHeader";
import { TextLink } from "../../atoms/Typography/Text/Text";
import { FormItemsWrap } from "../Wrap/Wrap";

export const PasswordForm = ({ onClick, t, state, dispatch }) => {
  const { control, handleSubmit, setError } = useForm({
    defaultValues: {
      password: "",
    },
    resolver: yupResolver(
      object({
        password: string().required(t("validation:required-field")),       
      }),
    ),
  });

  const navigate = useNavigate();
  const { startLoading, stopLoading, LoadingState } = useLoadingState();
  const onSubmit = async (formData) => {
    try {
      startLoading({ btnName: "signin" });
      await sendCredentialVerfication({
        emailAddress: state.user.email,
        password: formData.password,
      })
        .then((d) => {
          if (d.type === 0) {
            dispatch({ type: "SET_TOKEN_PAYLOAD", payload: d.data.token });
            dispatch({
              type: "SET_JWTDATA",
            });
            let role = JwtDecoder(d.data.token).roles;
            localStorage.setItem("authToken", d.data.token);

            onClick("pass", role);
          } else if (d.type == 3 && d.message) {
            setError("password", {
              message: t(d.message, { ns: "validation" }),
            });
            onClick("fail");
          } else if (d.message) {
            setError("password", {
              message: t("validation:invalid-password"),
            });
          }
        })
        .catch((e) => console.log(e));
      stopLoading();
    } catch (error) {}
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormItemsWrap gap={"32px"}>
        <PasswordInput
          hideValidBorderColor={true}
          width={"348px"}
          required={true}
          control={control}
          label={t("common:form.enter-password")}
          name={"password"}
          isInherit={true}
        />
        <LoadingButtonType
          loading={LoadingState.visible}
          type="submit"
          variant={"primaryBlue"}
          fullWidth
        >
          {t("common:button.login")}
        </LoadingButtonType>
      </FormItemsWrap>
      <FormItemsWrap
        marginTop={"18px"}
        justifyContent={"center"}
        direction={"row"}
      >
        <SubHeader4
          text={t("glossary:auth.password.have-trouble-logging-in")}
        />
        <TextLink
          text={t("glossary:auth.password.reset-password")}
          onClick={() => {
            navigate("/signin/forgot-password");
          }}
        />
      </FormItemsWrap>
    </form>
  );
};
